import { CommUser } from '../types/communication'

export const formatPersonsPayload = (
  persons,
  senderOrReceiver?: any,
  showDisplayName?: boolean
) => {
  const phNumber = senderOrReceiver ? senderOrReceiver.phoneNumber : ''
  return persons.map((person) => {
    let payload = persons
    if (person.contactId) {
      payload = {
        id: person.contactId,
        type: 'Contact',
        phoneNumber: person.contactDetails.defaultPhoneNumber
      }
    } else if (person.australisId) {
      payload = {
        id: person.australisId,
        type: 'User'
      }
    }
    if (phNumber && !payload.phoneNumber) payload.phoneNumber = phNumber
    if (showDisplayName) {
      const nameIds = person.displayName.split('|||')
      const [displayName] = nameIds
      payload.displayName = displayName.trim()
    }
    return payload
  })
}

export const mapDisplaysToString = (people: Array<CommUser>) => {
  const map = {}
  const filtered = []
  people.forEach((person) => {
    if (!map[person.phoneNumber]) {
      filtered.push(person)
    }

    map[person.phoneNumber] = person
  })

  return filtered.reduce((names, person, currentIndex) => {
    if (person.displayName) {
      names += person.displayName.split('|||')[0]
      if (currentIndex < filtered.length - 1) {
        names += ', '
      }
    }
    return names
  }, '')
}

/**
 * Get the display name and id from the contact object.
 *
 * @param opt - options object
 * @returns - a map of the display name and id
 */
export const getDisplayNameId = (opt) => {
  const { displayName } = opt
  const nameId = displayName.split('|||')
  return { name: nameId[0], id: nameId[1] }
}

/**
 * A utility function to highlight the selected option in the
 * Material UI Autocomplete component.
 *
 * @param option
 * @param selected
 * @returns - true if the option is selected, false otherwise
 */
export const validateOptions = (option: object, selected: object) => {
  if (!option || !selected) return false
  const opt = getDisplayNameId(option)
  const sel = getDisplayNameId(selected)
  const isValid = opt.name === sel.name && opt.id === sel.id
  return isValid
}

export const filterCommPersons = (options, { inputValue }) => {
  return options.filter((option) => {
    if (inputValue) {
      const searchStrings = inputValue.toLowerCase().trim().split(' ')
      return searchStrings.every((searchString) => {
        return option.displayName.toLowerCase().includes(searchString)
      })
    }
    return true
  })
}
